import { WidgetTypes } from '../../../../common/types/api/report'

export const decodeLabel = (type: WidgetTypes): string => {
    switch (type) {
        case WidgetTypes.PIPES:
            return 'HTML'
        case WidgetTypes.HTML:
            return 'Text'

        case WidgetTypes.GALLERY:
            return 'Gallery'
    }
}
